// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body {\n  margin: 0;\n  padding: 0;\n  font-family: 'Open Sans';\n}\n\nhtml, body, #root {\n  font-family: 'Open Sans';\n  overflow-x: hidden;\n  position: fixed;\n  height: 100%;\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
